import { render, staticRenderFns } from "./CityBtns.vue?vue&type=template&id=196cd0a4&"
import script from "./CityBtns.vue?vue&type=script&lang=js&"
export * from "./CityBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports